export default __webpack_public_path__ + "static/media/DentAndBuckle.2f6550fe.svg";